import { memo } from 'react';
import AssetSelectorDetailsHeader from './components/AssetSelectorDetailsHeader';
import { SensorAnalysisFilters } from './components/SensorAnalysisFilters';
import SensorAnalysisMainContent from './components/SensorAnalysisMainContent';
import { useAppSelector } from 'store/hook';
import { SingleFadeLoader } from 'components/SingleFadeLoader';

export const SensorAnalysisNew = memo(() => {
  const assetsLoaded = useAppSelector(
    (state) => state.assetReducer.assetsLoaded
  );

  if (!assetsLoaded) {
    return <SingleFadeLoader />;
  }

  return (
    <div style={{ padding: '10px' }}>
      {/* asset selector and asset details */}
      <AssetSelectorDetailsHeader />
      {/* filters - 
        - Quick Range
        - Custom Case:
          - regular data - date range filter & aggregation basis - avg, max, min
          - high grain data - date range filter & aggregation basis - avg, max, min
      */}
      <SensorAnalysisFilters />
      {/* Tag Selection and Charts */}
      <SensorAnalysisMainContent />
    </div>
  );
});

SensorAnalysisNew.displayName = 'SensorAnalysisNew';

export default SensorAnalysisNew;
